import { type ReactElement } from 'react';
import { Text } from '@vello/web-theme';
import { selfApprovalOf } from '../../src/index';
import { useVocab } from '../i18n/vocab';

/**
 * D868: beside who decided a record, the catalog sentence of how it passed four eyes with one operator
 * (`rbac.self_approval`, e.g. "Aprovado pelo superadministrador, sem segundo operador") — only when the record carries
 * `selfApproval`. Nothing otherwise: an ordinary decision by a second operator says nothing new.
 */
export function SelfApprovalNote({ record }: { readonly record: unknown }): ReactElement | null {
  const { v } = useVocab();
  const code = selfApprovalOf(record);
  if (code === undefined) return null;
  return <Text role="caption" tone="secondary" block data-testid="self-approval-note">{v('rbac.self_approval', code)}</Text>;
}
